import React from 'react';
import { useQuery } from '@apollo/client';
import { fetchUsersWithAccessToSurfaceQuery } from 'graphql/user/queries/fetch-users-with-access-to-surface';
import { SubSurfaceNode } from 'graphql/types';

interface UseUsersWithAccessOperations {
  users: any[];
  isLoading: boolean;
  removeUserByEmail(email: string): void;
}

export default function useUsersWithAccess(
  surface: SubSurfaceNode,
): UseUsersWithAccessOperations {
  const owner = { user: surface.owner, isOwner: true, role: 'OWNER' };

  const [users, setUsers] = React.useState([]);

  const { loading, previousData } = useQuery(
    fetchUsersWithAccessToSurfaceQuery,
    {
      variables: { surface: surface.id },
      pollInterval: 5000,
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        setUsers(data?.fetchUsersWithAccessToSurface.nodes || []);
      },
    },
  );

  function removeUserByEmail(email: string) {
    // @ts-ignore
    setUsers(users.filter(({ user }) => user?.email !== email));
  }

  return {
    users: [owner, ...users],
    isLoading: !previousData && loading,
    removeUserByEmail,
  };
}
